import { TIPTAP_HTML_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { Html as Component } from "./component";
const tiptapExtensions = [
  createRicosNodeExtension({
    name: TIPTAP_HTML_TYPE,
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    createExtensionConfig() {
      return {
        name: this.name,
        atom: false,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          source: null,
          containerData: null,
          url: null,
          html: null,
          isAdsense: null,
          autoHeight: { default: true },
          iframeHeight: null
        })
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
